import { subscribe } from "../emitter-subscriber/subscribe";
import { parsePayload } from "../utils/parse";
import { updateConfig } from "../config/config-store";
const createConfig = () => {
    const configSubscription = () => {
        subscribe("AAT_CONFIG_PASSIVE", (payload) => {
            const parsed = parsePayload(payload);
            updateConfig(parsed);
        });
    };
    return { configSubscription };
};
export const { configSubscription } = createConfig();



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/events/config.js
// module id = ./node_modules/@celine/passive-tracking/dist/events/config.js
// module chunks = 0